export class PasswordPreloginRequest {
  email: string;

  constructor(email: string) {
    this.email = email;
  }
}
